import { useState } from 'react';
import { toast } from 'react-toastify';

const useUserDetails = () => {
    const [userDetailsModal, setUserDetailsModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [loadingUser, setLoadingUser] = useState(false);

    const fetchUserDetails = async (userId) => {
        try {
            setLoadingUser(true);
            const authUser = JSON.parse(sessionStorage.getItem("authUser"));
            const contactMasked = authUser?.userContactMasked ? 1 : 0;
            const API_BASE_URL = process.env.REACT_APP_API_URL?.replace(/\/$/, '');
            
            const response = await fetch(`${API_BASE_URL}/python/users/?userId=${userId}&contactMasked=${contactMasked}`, {
                headers: {
                    'Authorization': authUser?.token || '',
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (data.result && data.result.length > 0) {
                setSelectedUser(data.result[0]);
                setUserDetailsModal(true);
            }
        } catch (error) {
            toast.error("Failed to fetch user details");
        } finally {
            setLoadingUser(false);
        }
    };

    return {
        userDetailsModal,
        setUserDetailsModal,
        selectedUser,
        loadingUser,
        fetchUserDetails
    };
};

export default useUserDetails; 